import Navigation from "../../components/Navigation";
// import Footer from "../../components/Footer";
// import { Badge } from "../../components/ui/badge";
import { ExternalLink } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Helmet } from "react-helmet-async";
import "./style.css";

const Portfolio = () => {
    const projects = [
		{
			title: "Videographer Website",
			description: "Showcasing stunning videography with a modern design",
			technologies: ["React", "CSS3"],
			category: "Portfolio",
			image:
				"/assets/images/david.png",
			link: "https://david-mk-portfolio.web.app",
		},
		{
			title: "Graphic Design Portfolio",
			description: "Showcasing stunning graphic designs and illustrations",
			technologies: ["React", "CSS3"],
			category: "Website",
			image:
				"/assets/images/bcgLogo.png",
			link: "https://bigcatgraphics.co.za/",
		},
		{
			title: "Couple Engagement Website",
			description: "Showcasing a beautiful love story for a couple's engagement",
			technologies: ["React", "Firebase", "CSS3"],
			category: "Website",
			image:
				"/assets/images/cover-photo.png",
			link: "https://ohboydwedding.web.app/",
		},
		{
			title: "Entertainment Review Website",
			description: "Our offering of reviews and ratings for movies, TV shows, and games (currently in development)",
			technologies: ["React", "Firebase", "CSS3", 'TMDB API'],
			category: "Website",
			image:
				"/assets/images/Logo.png",

			link: "https://ranthub.co.za",
		},
		{
			title: "Custom Invoice Generator",
			description: "Generate professional invoices with ease",
			technologies: ["React", "CSS3", "PDF Generation"],
			category: "Web Application",
			image:
				"/assets/images/Logo.png",
				link: "https://invoice-app.mftechs.co.za",
		},
		{
			title: "Jean Tax & Legal Practitioners Website",
			description: "A professional website for a tax and legal practice",
			technologies: ["React", "CSS3"],
			category: "Website",
			image:
				"/assets/images/jeantnl-logo.png",
			link: "https://jeantaxandlegal.co.za",
		},
		{
			title: "Blogging Platform",
			description: "A modern blogging platform for content creators",
			technologies: ["React", "Node.js", "Firebase", "CSS3"],
			category: "Web Application",
			image:
				"/assets/images/Logo.png",
			link: "https://twit.co.za/",
		}
		// {
		// 	title: "Landing Page",
		// 	description: "High-converting landing page with SEO optimization",
		// 	technologies: ["React", "CSS3", "SEO"],
		// 	category: "Website",
		// 	image:
		// 		"https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop",
		// },
	];

    return (
        <div className="portfolio-page">
            <Helmet>
                <title>Portfolio | Moonface Techs</title>
                <meta name="description" content="Explore our latest web design, web applications, and digital project collaborations at Moonface Techs." />
            </Helmet>

            <Navigation />

            <main className="portfolio-main">
                <section className="portfolio-hero-section">
                    <div className="portfolio-grid-texture" />
                    <div className="portfolio-glow-circle" />

                    <div className="portfolio-container">
                        <p className="rule-mono">
                            Selected work <span className="rule-line" />
                        </p>
                        <div className="portfolio-header">
                            <h1 className="portfolio-title">
                                Our{" "}
                                <span className="text-nebula-gradient portfolio-title-underline">
                                    Portfolio
                                </span>
                            </h1>
                            <p className="portfolio-subtitle">
                                Showcasing our latest projects and successful collaborations
                            </p>
                        </div>

                        <div className="portfolio-grid">
                            {projects.map((project) => (
                                <article
                                    key={project.title}
                                    className="portfolio-card"
                                >
                                    <span className="portfolio-card-accent" />

                                    <div className="portfolio-image-wrapper">
                                        <img
                                            src={project.image}
                                            alt={`${project.title} project by Moonface Techs`}
                                            loading="lazy"
                                            className="portfolio-image"
                                        />
                                        <div className="portfolio-image-overlay" />
                                        <span className="portfolio-category-badge">
                                            {project.category}
                                        </span>
                                    </div>

                                    <div className="portfolio-card-content">
                                        <h2 className="portfolio-card-title">
                                            {project.title}
                                        </h2>
                                        <p className="portfolio-card-desc">
                                            {project.description}
                                        </p>

										<div className="portfolio-card-footer">
                                        <div className="portfolio-tech-list">
                                            {project.technologies.map((tech) => (
                                                <span
                                                    key={tech}
                                                    // variant="outline"
                                                    className="portfolio-tech-badge"
                                                >
                                                    {tech}
                                                </span>
                                            ))}
                                        </div>

                                        <Button
                                            variant="ghost"
                                            className="portfolio-details-btn"
                                        >
											<a href={project.link} target="_blank" rel="noreferrer">
												View Details
												<ExternalLink className="portfolio-btn-icon" />
											</a>
                                        </Button>
										</div>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="portfolio-cta-section">
                    <div className="portfolio-container">
                        <div className="portfolio-cta-box">
                            <div>
                                <h2 className="portfolio-cta-title">
                                    Ready to Start Your Project?
                                </h2>
                                <p className="portfolio-cta-subtitle">
                                    Let's bring your vision to life with our expertise
                                </p>
                            </div>
                            <Button
                                size="lg"
                                className="submit-button"
                            >
                                <a href="/contact" rel="noreferrer">Get Free Quote</a>
                            </Button>
                        </div>
                    </div>
                </section>
            </main>

            {/* <Footer /> */}
        </div>
    );
};

export default Portfolio;